import { InjectionToken, Provider, Type } from '@angular/core';
import { CinevillePassModel } from '@digilize/shared/definitions/src';
import { Observable } from 'rxjs';

export interface User {
  email: string;
  firstname: string;
  lastname: string;
  newsletter: boolean;
  phone?: string;
  cvPass?: CinevillePassModel[];
  agreement2?: boolean; // newsletter
  shopIds?: string[] | null;
}

export interface UpdateUserPayload {
  first_name?: string;
  last_name?: string;
  phone?: string;
}

export abstract class AuthStrategy {
  abstract login(login: string, password: string): Observable<User>;

  abstract logout(): Observable<boolean>;

  abstract register(data: {
    email: string;
    firstname: string;
    lastname: string;
    password: string;
    confirmPassword: string;
  }): Observable<User>;

  abstract updateUser(user: UpdateUserPayload): Observable<User>;

  abstract remindPassword(email: string): Observable<boolean>;

  abstract resetPassword(token: string, password: string, confirmPassword: string): Observable<boolean>;

  abstract getUser(): Observable<User>;

  abstract exists(email: string): Observable<boolean>;
}

export const AUTH_STRATEGY = new InjectionToken<AuthStrategy>('AUTH_STRATEGY');

export const provideAuthStrategy = (strategy: Type<AuthStrategy>): Provider => {
  return {
    provide: AUTH_STRATEGY,
    useClass: strategy,
  };
};
